module.exports = __webpack_public_path__ + "static/media/harvard.89952671.png";